module.exports = __webpack_public_path__ + "img/price-rounded.9b873eb8.svg";